import { Box, Container, Grid } from "@mui/material";
import {
  InfoOperater,
  Loading,
  OperaterKojiJeIzvjestio,
  OslobodjenOdIzvjescivanja,
  Poruka,
} from "../../components";
import { FormProvider, useForm } from "react-hook-form";
import { useContext, useEffect } from "react";
import axios from "axios";
import {
  OSLOBODJEN_OD_IZVJESCIVANJA,
  TIP_INFO_PORUKE,
  TIP_IZVJESCA,
  VRSTA_OPERATERA,
} from "../../enums";
import Button from "@mui/material/Button";
import { Context } from "../../context";
import { useMojiPodaci } from "../../hooks";

type Izdavatelj = {
  oznaka: string;
  euSifra: string;
};

type VrstaIdentifikatora = {
  id: number;
  opis: string;
};

type Identifikator = {
  id: number;
  vrstaIdentifikatora: VrstaIdentifikatora;
  drzavaIzdavatelj: Izdavatelj;
  identifikacijskiBroj: string;
};

type TipElektronickeAdrese = {
  id: number;
  opis?: string;
};

type ElektronickaAdresa = {
  adresa: string;
  tip: TipElektronickeAdrese;
};

type Drzava = {
  naziv?: string;
  oznaka: string;
  euSifra: string;
};

type Adresa = {
  drzava: Drzava;
  mjesto: string;
  regija?: string;
  postanskiBroj?: string;
  okrug?: string;
  ulica?: string;
  kucniBroj?: string;
};

type Naziv = {
  id: number;
  naziv: string;
};

export type Operater = {
  id: number;
  naziv: Naziv;
  drzava: Drzava;
  identifikator?: Identifikator[];
};

interface FormValues {
  naziv: string;
  oslobodjenOdIzvjescivanja: number | string;
  drzaveEu: Drzava[];
  drzaveEuTemp: Drzava[];
  loading: boolean;
  infoPoruka: string;
  tipIzvjesca: number | string | null;
  tipInfoPoruke: number | null;
  postojiOslobodjenje: boolean;
}
const Index = () => {
  const methods = useForm<FormValues>({
    defaultValues: {
      naziv: "",
      oslobodjenOdIzvjescivanja: OSLOBODJEN_OD_IZVJESCIVANJA.NE.toString(),
      drzaveEu: [],
      drzaveEuTemp: [],
      loading: true,
      infoPoruka: "",
      tipIzvjesca: TIP_IZVJESCA.IZVAN_RH.toString(),
      tipInfoPoruke: null,
      postojiOslobodjenje: false,
    },
  });
  const [{ token }] = useContext(Context);
  const { operaterPlatforme } = useMojiPodaci(methods);
  const oslobodjenOdIzvjescivanja = methods.watch("oslobodjenOdIzvjescivanja");
  const tipIzvjesca = methods.watch("tipIzvjesca");
  const loading = methods.watch("loading");
  const postojiOslobodjenje = methods.watch("postojiOslobodjenje");

  useEffect(() => {
    const getData = async () => {
      try {
        const resOperater = await axios.get(
          `${process.env.REACT_APP_API_URL}/zahtjevi/oslobodjenje`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const resDrzave = await axios.get(
          `${process.env.REACT_APP_API_URL}/sifrarnici/drzave-eu`
        );

        if (resDrzave.status === 200 && resOperater.status === 200) {
          const { data: drzaveEu } = resDrzave;
          const { data: operater } = resOperater;

          if (operater.message) return;

          methods.reset((formValues) => ({
            ...formValues,
            postojiOslobodjenje: true,
            oslobodjenOdIzvjescivanja:
              OSLOBODJEN_OD_IZVJESCIVANJA.DA.toString(),
            naziv: operater.nazivIzvjestitelja,
            drzavaIzvjestavanja: {
              oznaka: [
                ...drzaveEu,
                { oznaka: "HR", euSifra: "HR", naziv: "Hrvatska (HR)" },
              ]?.find(
                (drzava: Drzava) =>
                  drzava.euSifra === operater.drzavaIzvjestitelja
              )?.oznaka,
              euSifra: [
                ...drzaveEu,
                { oznaka: "HR", euSifra: "HR", naziv: "Hrvatska (HR)" },
              ]?.find(
                (drzava: Drzava) =>
                  drzava.euSifra === operater.drzavaIzvjestitelja
              )?.euSifra,
            },
            identifikacijskiBroj: operater.tinIzvjestitelja,
            drzavaIzdavatelj: {
              oznaka: [
                ...drzaveEu,
                { oznaka: "HR", euSifra: "HR", naziv: "Hrvatska (HR)" },
              ]?.find(
                (drzava: Drzava) =>
                  drzava.euSifra === operater.drzavaIzdavatelja
              )?.oznaka,
              euSifra: [
                ...drzaveEu,
                { oznaka: "HR", euSifra: "HR", naziv: "Hrvatska (HR)" },
              ]?.find(
                (drzava: Drzava) =>
                  drzava.euSifra === operater.drzavaIzdavatelja
              )?.euSifra,
            },
            tipIzvjesca:
              operater.drzavaIzvjestitelja === "HR"
                ? TIP_IZVJESCA.IZ_RH.toString()
                : TIP_IZVJESCA.IZVAN_RH.toString(),
            drzaveEu:
              operater.drzavaIzvjestitelja === "HR"
                ? [
                    ...drzaveEu,
                    { oznaka: "HR", euSifra: "HR", naziv: "Hrvatska (HR)" },
                  ].sort((a: Drzava, b: Drzava) =>
                    a.oznaka.localeCompare(b.oznaka)
                  )
                : drzaveEu,
            drzaveEuTemp: [...drzaveEu],
            loading: false,
          }));
        }
      } catch (e) {
        const resDrzave = await axios.get(
          `${process.env.REACT_APP_API_URL}/sifrarnici/drzave-eu`
        );

        if (resDrzave.status !== 200) return;

        const { data: drzaveEu } = resDrzave;
        methods.reset((formValues) => ({
          ...formValues,
          drzaveEu,
          drzaveEuTemp: drzaveEu,
          loading: false,
        }));
      }
    };

    getData();
  }, []);

  const onSubmit = async (data: FormValues) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/zahtjevi/oslobodjenje`,
        { ...data },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        methods.setValue("infoPoruka", response.data.message);
        methods.setValue("tipInfoPoruke", TIP_INFO_PORUKE.SUCCESS);
      }
    } catch (error: any) {
      const { status } = error.response;
      if (status === 400) {
        if (error.response.data.errors) {
          error.response.data.errors.forEach((error: any) =>
            methods.setError(error.fieldName, { message: error.error })
          );
          return;
        }

        if (error.response.data.message) {
          methods.setValue("infoPoruka", error.response.data.message);
          methods.setValue("tipInfoPoruke", TIP_INFO_PORUKE.ERROR);
        }
      }
    }
  };

  if (
    !operaterPlatforme ||
    Object.keys(operaterPlatforme).length === 0 ||
    operaterPlatforme.vrstaOperatera.id === VRSTA_OPERATERA.IZVAN_EU
  )
    return null;

  return (
    <FormProvider {...methods}>
      {!loading && (
        <Container>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Box
                component={"form"}
                onSubmit={(e) => {
                  methods.clearErrors();
                  methods.handleSubmit(onSubmit)(e);
                }}
              >
                <InfoOperater />
                <OslobodjenOdIzvjescivanja />
                {oslobodjenOdIzvjescivanja ==
                  OSLOBODJEN_OD_IZVJESCIVANJA.DA && (
                  <>
                    <OperaterKojiJeIzvjestio />
                    {postojiOslobodjenje && (
                      <p>
                        Imate status <i>Oslobođeni operater</i>.
                      </p>
                    )}
                    {oslobodjenOdIzvjescivanja !==
                      OSLOBODJEN_OD_IZVJESCIVANJA.DA &&
                      !postojiOslobodjenje && (
                        <Grid
                          container
                          justifyContent={"flex-end"}
                          sx={{ mt: 3 }}
                        >
                          <Button variant={"contained"} type={"submit"}>
                            Spremi promjene (Save changes)
                          </Button>
                        </Grid>
                      )}
                  </>
                )}
              </Box>
            </Grid>
          </Grid>
        </Container>
      )}
      <Loading />
      <Poruka refreshPageOnClose={true} />
    </FormProvider>
  );
};

export default Index;
